import { configs } from "configs"
import { isTenantBayut, isTenantZameen } from "constants/tenant"
import { numberConvertor } from "utils"

export const getCurrencySymbol = () => {
  return configs?.currencySymbolUnicode ? (
    <span className={configs?.currencySymbolClass} style={{ textTransform: "none" }}>
      {String.fromCharCode(configs.currencySymbolUnicode)}
    </span>
  ) : (
    <>{configs?.currency}</>
  )
}

export const getCompactCurrencyType = () => {
  if (isTenantZameen) return "local"
  if (isTenantBayut) return "intl"
  return "intl"
}
